import React from 'react';
import { format } from 'date-fns';

export const dryingCyclesColumns = [
  {
    id: 'fecha',
    label: 'Fecha',
    type: 'daterange',
    sortable: true,
    required: true,
    isFilter: true,
    isForm: true,
    render: (row) => {
      try {
        const value = row.fecha;
        if (!value) return '-';
        const date = new Date(value);
        if (isNaN(date.getTime())) return 'Fecha inválida';
        return format(date, 'dd/MM/yyyy');
      } catch (error) {
        console.error('Error al formatear fecha:', error);
        return 'Fecha inválida';
      }
    },
  },
  {
    id: 'maquina',
    label: 'Máquina',
    type: 'select',
    sortable: true,
    required: true,
    isFilter: true,
    options: [],
    getFilterValueLabel: (value, options) => {
      const option = options.find(opt => opt.value === value);
      return option ? option.label : value;
    },
    render: (row) => {
      try {
        const value = row.maquina;
        if (!value) return '-';
        if (typeof value === 'object') return value.nombre || '-';
        return String(value);
      } catch (error) {
        console.error('Error al renderizar máquina:', error);
        return '-';
      }
    },
  },
  {
    id: 'estado',
    label: 'Estado',
    sortable: false,
    isFilter: false,
    isForm: false,
    render: (row) => {
      if (row.abortado) {
        return (
          <div className="flex flex-col gap-0.5">
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-700 dark:bg-red-950/40 dark:text-red-400 w-fit">
              ⊘ Abortado
            </span>
            {row.razonAbortado && (
              <span className="text-xs text-muted-foreground">{row.razonAbortado}</span>
            )}
          </div>
        );
      }
      return (
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-700 dark:bg-green-950/40 dark:text-green-400 w-fit">
          ✓ Completado
        </span>
      );
    },
  },
  {
    id: 'ciclos',
    label: 'Ciclos',
    type: 'number',
    sortable: true,
    required: true,
    render: (row) => {
      try {
        const value = row.ciclos;
        if (value === null || value === undefined) return '-';
        return String(value);
      } catch (error) {
        console.error('Error al renderizar ciclos:', error);
        return '-';
      }
    },
  },
  {
    id: 'kilosSecados',
    label: 'Kilos Secados',
    type: 'number',
    sortable: true,
    isForm: false,
    render: (row) => {
      try {
        const value = row.kilosSecados;
        if (value === null || value === undefined) return '-';
        const numValue = Number(value);
        if (isNaN(numValue)) return '0 kg';
        return `${numValue.toLocaleString()} kg`;
      } catch (error) {
        console.error('Error al formatear kilos secados:', error);
        return '0 kg';
      }
    },
  },
  {
    id: 'capacidad',
    label: 'Capacidad Nominal(kg)',
    type: 'number',
    sortable: true,
    isForm: false,
    render: (row) => {
      try {
        const value = row.capacidad;
        if (value === null || value === undefined) return '-';
        const numValue = Number(value);
        if (isNaN(numValue)) return '0 kg';
        return `${numValue} kg`;
      } catch (error) {
        console.error('Error al renderizar capacidad nominal:', error);
        return '0 kg';
      }
    },
  },
  {
    id: 'contador',
    label: 'Contador',
    type: 'number',
    sortable: true,
    required: true,
    isForm: true,
    render: (row) => {
      try {
        const value = row.contador;
        if (value === null || value === undefined) return '-';
        return String(value);
      } catch (error) {
        console.error('Error al renderizar contador:', error);
        return '-';
      }
    },
  },
  {
    id: 'contadorNuevo',
    label: 'Contador Nuevo',
    type: 'number',
    sortable: true,
    required: true,
    isForm: true,
    render: (row) => {
      try {
        const value = row.contadorNuevo;
        if (value === null || value === undefined) return '-';
        return String(value);
      } catch (error) {
        console.error('Error al renderizar contador nuevo:', error);
        return '-';
      }
    },
  },
];

export const columnsExcel = [
  { key: 'fecha', header: 'Fecha', formatDate: true },
  { key: 'maquina.nombre', header: 'Máquina' },
  { key: 'ciclos', header: 'Ciclos' },
  { key: 'capacidad', header: 'Capacidad Nominal (kg)' },
  { key: 'kilosSecados', header: 'Kilos Secados' },
  { key: 'abortado', header: 'Abortado' },
  { key: 'razonAbortado', header: 'Razón Abortado' },
  { key: 'contador', header: 'Contador' },
  { key: 'contadorNuevo', header: 'Contador Nuevo' },
  { key: 'createdAt', header: 'Fecha de Registro', formatDate: true },
];
